import React from "react";
import AppButton from "./AppButton";

const SubmitButton = ({
  title,
  loadingText = "Please wait...",
  loading = false,
  disabled = false,
  startIcon,
  endIcon,
  variant = "gradient",
  color = "primary",
  fullWidth = true,
  pill = false,
  onClick,
  sx = {},
  ...props
}) => {
  return (
    <AppButton
      type="submit"
      onClick={onClick}
      isLoading={loading}
      loadingText={loadingText}
      disabled={disabled}
      variant={variant}
      color={color}
      fullWidth={fullWidth}
      size="large" // Submit buttons are usually large
      pill={pill}
      startIcon={startIcon}
      endIcon={endIcon}
      sx={{
        fontSize: "1rem",
        ...sx,
      }}
      {...props}
    >
      {title}
    </AppButton>
  );
};

export default SubmitButton;
